import React from 'react';
import PropTypes from 'prop-types';
import TaskModule from 'modules/task';
import MobileHeader from 'pages/mobileHeader';
import { connect } from 'react-redux';
import ReduxActions from 'reduxActions';
import { Components, Utils, translate } from 'versafleet-core';
import { isUserReadOnly } from 'utils/accessHelper';
import FilterPage from '../filterPage';

const { Router, FullScreenLoading, Helper } = Utils;

const SORT_OPTIONS = [{
  value: 'id',
  text: 'Created at',
  ascendingText: 'oldest first',
  descendingText: 'newest first',
}, {
  value: 'time_from',
  text: 'Time window',
  ascendingText: 'oldest first',
  descendingText: 'newest first',
}, {
  value: 'updated_at',
  text: 'Last updated',
  ascendingText: 'oldest first',
  descendingText: 'newest first',
}, {
  value: 'billing_accounts.name',
  text: 'Account name',
  ascendingText: 'A to Z',
  descendingText: 'Z to A',
}];

class ArchivedTaskPage extends React.Component {
  constructor(props) {
    super(props);
    const filter = this._getDefaultFilter();
    this.state = {
      filter,
      showFilterPage: false,
    };
  }

  UNSAFE_componentWillMount() {
    this._loadList();
    this.props.dispatch(ReduxActions.constant.fetchList());
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.filter !== this.state.filter) {
      this._loadList();
    }
  }

  _loadList() {
    FullScreenLoading.FullScreenLoadingManager.open(this.props.strings.Task.page.loadingItems);
    this.props.dispatch(ReduxActions.task.fetchArchivedList(this.state.filter))
      .then(() => {
        FullScreenLoading.FullScreenLoadingManager.close();
      });
  }

  _getDefaultFilter() {
    return {
      date: this.props.filter.date,
      keyword: '',
      state: this._getTaskStatusOptions().map(option => option.value),
      sort_by: SORT_OPTIONS[0].value,
      page: 1,
      per_page: 20,
      order_by: 'desc',
      archived: true,
      job_type: ['pickup', 'delivery', 'p2p'],
      tags: [],
    };
  }

  _onFilterChange(fieldName, value) {
    // For iOS, try to block the input date from changing the date to none
    if (fieldName === 'date' && (
      Helper.isNullOrUndefined(value) || !Helper.isNonEmptyString(value)
    )) {
      return;
    }

    const newFilter = Helper.setFilter(this.state.filter, fieldName, value);
    this._updateFilters(newFilter);
  }

  _updateFilters(filter) {
    // Check if any of the keys exist in
    // the filter store. If so, update the filter store to the filter changed
    // here
    const myJobsFilter = this.props.filter;
    Object.keys(myJobsFilter).forEach((key) => {
      if (typeof filter[key] !== 'undefined') {
        myJobsFilter[key] = filter[key];
      }
    });

    this.props.dispatch(ReduxActions.filter.updateMyJobsTaskFilter(myJobsFilter));

    this.setState({ filter });
  }

  _getTaskStatusOptions() {
    const strings = this.props.strings.Task.status;
    return [{
      text: strings.unassigned,
      value: 'unassigned',
    }, {
      text: strings.assigned,
      value: 'assigned',
    }, {
      text: strings.waiting_for_acknowledgement,
      value: 'waiting_for_acknowledgement',
    }, {
      text: strings.acknowledged,
      value: 'acknowledged',
    }, {
      text: strings.started,
      value: 'started',
    }, {
      text: strings.successful,
      value: 'successful',
    }, {
      text: strings.failed,
      value: 'failed',
    }, {
      text: strings.declined,
      value: 'declined',
    }, {
      text: strings.cancelled,
      value: 'cancelled',
    }, {
      text: strings.collected,
      value: 'collected',
    }];
  }

  _renderActionPanel() {
    return (
      <Components.Mobile.ActionPanel className="vf-mobile-task-page__action-panel">
        <div className="vf-mobile-task-page__action-panel__content">
          <Components.Paginator
            className="vf-mobile-task-page__action-panel__content__paginator"
            currentPage={this.props.meta.page}
            id="vf-mobile-archive-task-page__paginator"
            isCountCustomizable
            itemsPerPage={this.props.meta.per_page}
            model="tasks"
            onChange={(key, val) => this._onFilterChange(key, val)}
            totalItems={this.props.meta.total}
          />
          <Components.Input.DatePicker
            id="vf-mobile-archive-task-page__datepicker"
            onChange={val => this._onFilterChange('date', val)}
            value={this.state.filter.date}
          />
        </div>
        {!isUserReadOnly() ? (
          <Components.Button
            iconClassName="versa-add"
            id="vf-mobile-archive-task-page__new-job-button"
            onClick={() => { Router.transitionTo('/jobs/new'); }}
            showShadow={false}
          />
        ) : false}
      </Components.Mobile.ActionPanel>
    );
  }

  _renderFilterPage() {
    return this.state.showFilterPage ? (
      <FilterPage
        filter={this.state.filter}
        id="vf-mobile-archive-task-page__filter-page"
        onChange={(filter) => {
          this.setState({ showFilterPage: false });
          this._updateFilters(filter);
        }}
        onClose={() => this.setState({ showFilterPage: false })}
        sortOptions={SORT_OPTIONS}
        statusOptions={this._getTaskStatusOptions()}
        tagList={this.props.taskTags || []}
        title="Filter & Sort Tasks"
      />
    ) : null;
  }

  render() {
    return (
      <div className="vf-mobile-task-page">
        <MobileHeader
          id="vf-mobile-archive-task-page__mobile-header"
          onFilterClick={() => this.setState({ showFilterPage: true })}
          onTagClick={() => Router.transitionTo('/archives/jobs')}
          tag="Tasks"
          title="Archives"
        />
        <div>
          {this._renderActionPanel()}
        </div>
        {this.props.tasks.map(task => (
          <TaskModule.MobileLineItem
            data={task}
            id="vf-mobile-archive-task-page__line-item"
            onAction={() => {}}
          />
        ))}
        {this.state.showFilterPage ? this._renderFilterPage() : false}
        {this.props.children}
      </div>
    );
  }
}

ArchivedTaskPage.propTypes = {
  children: PropTypes.node,
  dispatch: PropTypes.func.isRequired,
  filter: PropTypes.shape({
    date: PropTypes.string,
  }).isRequired,
  meta: PropTypes.shape({
    page: PropTypes.number,
    per_page: PropTypes.number,
    total: PropTypes.number,
  }).isRequired,
  strings: PropTypes.shape({
    Task: PropTypes.shape({
      page: PropTypes.shape({
        loadingItems: PropTypes.string,
      }),
      status: PropTypes.shape({
        unassigned: PropTypes.string,
        assigned: PropTypes.string,
        waiting_for_acknowledgement: PropTypes.string,
        acknowledged: PropTypes.string,
        started: PropTypes.string,
        successful: PropTypes.string,
        failed: PropTypes.string,
        declined: PropTypes.string,
        cancelled: PropTypes.string,
        collected: PropTypes.string,
      }),
    }),
  }).isRequired,
  taskTags: PropTypes.arrayOf(PropTypes.string),
  tasks: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

ArchivedTaskPage.defaultProps = {
  children: null,
  taskTags: [],
};

function mapStateToProps(state) {
  const { task, filter, constant } = state;
  return {
    filter: {
      ...filter.filter.task,
      date: filter.filter.myJobs.date,
    },
    meta: task.archivedTaskMeta,
    tasks: task.archivedTaskIds.map(id => task.tasks[id]),
    taskTags: constant.constant.tasks.tags,
  };
}

export default connect(mapStateToProps)(translate('')(ArchivedTaskPage));
